import styled from "styled-components/macro";

export const ImgPulse = styled.img`
  grid-area: pulse;
`;




export const NoAlarmContainer = styled.div`
  position: absolute;
  bottom:${({ landscape }) => (landscape ? "10%" : "13%")} ;
  left:${({ landscape }) => (landscape ? "4%" : "%")} ;

  background: black;
  width:${({ landscape }) => (landscape ? "30px" : "55px")} ;

  padding-top:${({ landscape }) => (landscape ? "1em" : "1em")} ;

`;
